import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css";

const Banks = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  const [banks, setBanks] = useState([
    { bankName: "Bank of Ceylon", branchName: "Colombo", status: "Active", id: 1 },
    { bankName: "Commercial Bank", branchName: "Kandy", status: "Inactive", id: 2 },
    { bankName: "Hatton National Bank", branchName: "Galle", status: "Active", id: 3 },
    { bankName: "Sampath Bank", branchName: "Jaffna", status: "Active", id: 4 },
  ]);

  const [formData, setFormData] = useState({
    bankName: "",
    branchName: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [banks]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedBank) {
      setBanks(
        banks.map((bank) =>
          bank.id === selectedBank.id ? { ...formData, id: bank.id } : bank
        )
      );
    } else {
      setBanks([
        ...banks,
        {
          ...formData,
          id: banks.length ? banks[banks.length - 1].id + 1 : 1,
        },
      ]);
    }
    setFormData({ bankName: "", branchName: "", status: "Active" });
    setSelectedBank(null);
    setShowForm(false);
  };

  const handleEdit = (bank) => {
    setSelectedBank(bank);
    setFormData({
      bankName: bank.bankName,
      branchName: bank.branchName,
      status: bank.status,
    });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedBank(null);
    setFormData({ bankName: "", branchName: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="bank-management d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left side form box */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedBank ? "Edit Bank" : "Add Bank"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Bank Name:</label>
              <input
                type="text"
                name="bankName"
                value={formData.bankName}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Branch Name:</label>
              <input
                type="text"
                name="branchName"
                value={formData.branchName}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Right side table box */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Banks & Branches</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Bank
            </button>
          </div>
          <div className="card-body">
            <table ref={tableRef} className="table table-bordered display" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Bank Name</th>
                  <th>Branch Name</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {banks.map((bank) => (
                  <tr key={bank.id}>
                    <td>{bank.bankName}</td>
                    <td>{bank.branchName}</td>
                    <td>
                      <span
                        className={`badge ${
                          bank.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {bank.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(bank)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banks;
